import getTabErrors from "@/helpers/forms/getTabErrors";
import isValidPassword from "@/helpers/forms/isValidPassword";
import { validate } from "@/helpers/forms/validate";

export default {
  getTabErrors,
  isValidPassword,
  validate,
};
